declare namespace $ {

	type $mol_link_source__uri_mynamespace_myapp_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $mynamespace_myapp_button__title_mynamespace_myapp_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mynamespace_myapp_button['title'] >
	>
	type $mol_link__title_mynamespace_myapp_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_mynamespace_myapp_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_page__body_mynamespace_myapp_app_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_mynamespace_myapp_app_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_mynamespace_myapp_app_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_mynamespace_myapp_app_8 = $mol_type_enforce<
		ReturnType< $mynamespace_myapp_app['name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_view__sub_mynamespace_myapp_app_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_mynamespace_myapp_app_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_mynamespace_myapp_app_11 = $mol_type_enforce<
		ReturnType< $mynamespace_myapp_app['increment'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_mynamespace_myapp_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_mynamespace_myapp_app_13 = $mol_type_enforce<
		ReturnType< $mynamespace_myapp_app['reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_row__sub_mynamespace_myapp_app_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_page__title_mynamespace_myapp_app_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_mynamespace_myapp_app_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_mynamespace_myapp_app_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_mynamespace_myapp_app_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_row__sub_mynamespace_myapp_app_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_string__hint_mynamespace_myapp_app_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_mynamespace_myapp_app_21 = $mol_type_enforce<
		ReturnType< $mynamespace_myapp_app['profile_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_mynamespace_myapp_app_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_mynamespace_myapp_app_23 = $mol_type_enforce<
		ReturnType< $mynamespace_myapp_app['profile_email'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_view__sub_mynamespace_myapp_app_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_mynamespace_myapp_app_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_page__title_mynamespace_myapp_app_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_mynamespace_myapp_app_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $mynamespace_myapp_app extends $mol_book2_catalog {
		Logo2( ): $mynamespace_myapp_logo
		Theme( ): $mol_theme_auto
		Sources( ): $mol_link_source
		Lighter( ): $mol_lights_toggle
		Logout_button( ): $mynamespace_myapp_button
		Docs_uri( ): $mol_link
		Docs( ): $mol_page
		greeting( ): string
		Greeting( ): $mol_view
		name( next?: string ): string
		Name_input( ): $mol_string
		count_text( ): string
		Count_label( ): $mol_view
		increment( next?: any ): any
		Increment( ): $mol_button_major
		reset( next?: any ): any
		Reset( ): $mol_button_minor
		Counter_row( ): $mol_row
		Page1( ): $mol_page
		profile_id_label( ): string
		Profile_id_label( ): $mol_view
		profile_id( ): string
		Profile_id( ): $mol_view
		Profile_id_row( ): $mol_row
		profile_name( next?: string ): string
		Profile_name( ): $mol_string
		profile_email( next?: string ): string
		Profile_email( ): $mol_string
		profile_status( ): string
		Profile_status( ): $mol_view
		Profile_hint( ): $mol_text
		Page2( ): $mol_page
		menu_title( ): string
		Menu_logo( ): ReturnType< $mynamespace_myapp_app['Logo2'] >
		param( ): string
		plugins( ): readonly(any)[]
		menu_tools( ): readonly(any)[]
		menu_foot( ): readonly(any)[]
		Spread_default( ): ReturnType< $mynamespace_myapp_app['Docs'] >
		spreads( ): ({ 
			'hello': ReturnType< $mynamespace_myapp_app['Page1'] >,
			'profile': ReturnType< $mynamespace_myapp_app['Page2'] >,
		}) 
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map